import { withProductionStyles } from "../../../../styles/withProductionStyles";
import EliteProduction from "./EliteProduction";

// Route.component is a React component type. Keep it stable across App renders
// (auth/header/instance updates), so those renders do not remount the board.
const ProductionBoardRoute = withProductionStyles(EliteProduction);

export default ProductionBoardRoute;
